import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = '';

const LANGUAGES = [
  '영어', '일본어', '중국어(간체)', '중국어(번체)', '스페인어',
  '프랑스어', '독일어', '베트남어', '태국어', '인도네시아어',
  '러시아어', '포르투갈어', '아랍어', '힌디어', '한국어'
];

const STYLES = [
  { value: 'natural', label: '자연스러운', desc: '일반적인 번역' },
  { value: 'formal', label: '격식체', desc: '공손하고 정중한 표현' },
  { value: 'casual', label: '일상체', desc: '편하고 친근한 표현' },
  { value: 'business', label: '비즈니스', desc: '공식 문서/이메일용' },
  { value: 'technical', label: '기술 문서', desc: '기술 용어 정확 유지' },
];

function TranslateAgent() {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [target, setTarget] = useState('영어');
  const [style, setStyle] = useState('natural');
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [mode, setMode] = useState('text');

  const handleTranslate = async () => {
    if (mode === 'text' && !text.trim()) return alert('번역할 텍스트를 입력해주세요.');
    if (mode === 'file' && !file) return alert('파일을 선택해주세요.');
    setLoading(true);
    setResult('');
    try {
      let res;
      if (mode === 'text') {
        res = await fetch(`${API}/translate`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text, target, style })
        });
      } else {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('target', target);
        formData.append('style', style);
        res = await fetch(`${API}/translate/file`, { method: 'POST', body: formData });
      }
      const data = await res.json();
      setResult(data.translated || data.error);
    } catch (e) {
      setResult('번역 실패');
    }
    setLoading(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(result);
    alert('복사되었습니다.');
  };

  const handleSwap = () => {
    if (result && target === '영어') {
      setText(result);
      setResult('');
      setTarget('한국어');
    } else if (result && target === '한국어') {
      setText(result);
      setResult('');
      setTarget('영어');
    } else {
      setText(result);
      setResult('');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      {/* 상단 네비게이션 */}
      <div style={{
        background: 'linear-gradient(135deg, #7b1fa2, #aa47bc)',
        padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 16
      }}>
        <button onClick={() => navigate('/')}
          style={{
            background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white',
            width: 36, height: 36, borderRadius: 8, cursor: 'pointer', fontSize: 18,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12 4l-6 6 6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div>
          <div style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>번역 에이전트</div>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>CLSOFTLAB AI SERVICE</div>
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: '24px auto', padding: '0 20px 40px' }}>
        {/* 설정 영역 */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
          <select value={target} onChange={e => setTarget(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #ccc', fontSize: 14 }}>
            {LANGUAGES.map(l => <option key={l} value={l}>{l}</option>)}
          </select>
          <select value={style} onChange={e => setStyle(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #ccc', fontSize: 14 }}>
            {STYLES.map(s => <option key={s.value} value={s.value}>{s.label} - {s.desc}</option>)}
          </select>
          <div style={{ display: 'flex', background: '#e0e0e0', borderRadius: 6, overflow: 'hidden' }}>
            <button onClick={() => setMode('text')}
              style={{
                padding: '8px 16px', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 'bold',
                background: mode === 'text' ? '#7b1fa2' : 'transparent',
                color: mode === 'text' ? 'white' : '#555',
              }}>텍스트</button>
            <button onClick={() => setMode('file')}
              style={{
                padding: '8px 16px', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 'bold',
                background: mode === 'file' ? '#7b1fa2' : 'transparent',
                color: mode === 'file' ? 'white' : '#555',
              }}>파일</button>
          </div>
        </div>

        {/* 번역 영역 */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: 12, alignItems: 'start' }}>
          {/* 입력 */}
          <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', overflow: 'hidden' }}>
            <div style={{ padding: '10px 16px', background: '#fafafa', borderBottom: '1px solid #eee', fontSize: 13, color: '#888', fontWeight: 'bold' }}>
              원문 {mode === 'file' ? '(파일)' : ''}
            </div>
            {mode === 'text' ? (
              <textarea value={text} onChange={e => setText(e.target.value)}
                placeholder="번역할 텍스트를 입력하세요..."
                style={{
                  width: '100%', minHeight: 300, padding: 16, border: 'none', outline: 'none',
                  fontSize: 15, lineHeight: 1.7, resize: 'vertical', boxSizing: 'border-box',
                  fontFamily: 'inherit'
                }} />
            ) : (
              <div style={{ padding: 20, minHeight: 300, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <rect x="8" y="8" width="32" height="32" rx="4" fill="#f3e8fd" stroke="#7b1fa2" strokeWidth="2"/>
                  <path d="M24 18v12M18 24h12" stroke="#7b1fa2" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <input type="file"
                  accept=".txt,.pdf,.docx,.xlsx,.csv,.json,.png,.jpg,.jpeg"
                  onChange={e => setFile(e.target.files[0])}
                  style={{ fontSize: 14 }} />
                {file && <p style={{ color: '#7b1fa2', fontSize: 13, margin: 0 }}>{file.name}</p>}
              </div>
            )}
            <div style={{ padding: '8px 16px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {mode === 'text' && <span style={{ fontSize: 12, color: '#aaa' }}>{text.length}자</span>}
              {mode === 'file' && <span style={{ fontSize: 12, color: '#aaa' }}>파일 번역</span>}
              <button onClick={handleTranslate} disabled={loading}
                style={{
                  padding: '8px 24px', background: loading ? '#ccc' : '#7b1fa2', color: 'white',
                  border: 'none', borderRadius: 6, cursor: loading ? 'not-allowed' : 'pointer',
                  fontSize: 14, fontWeight: 'bold'
                }}>
                {loading ? '번역중...' : '번역하기'}
              </button>
            </div>
          </div>

          {/* 가운데 스왑 버튼 */}
          <div style={{ display: 'flex', alignItems: 'center', paddingTop: 150 }}>
            <button onClick={handleSwap} title="입력/결과 교체"
              style={{
                width: 40, height: 40, borderRadius: '50%', border: '2px solid #7b1fa2',
                background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M6 8l-4 4 4 4M14 4l4 4-4 4" stroke="#7b1fa2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12h16M18 8H2" stroke="#7b1fa2" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

          {/* 결과 */}
          <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', overflow: 'hidden' }}>
            <div style={{ padding: '10px 16px', background: '#fafafa', borderBottom: '1px solid #eee', fontSize: 13, color: '#888', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>번역 결과 ({target})</span>
              {result && (
                <button onClick={handleCopy}
                  style={{ padding: '4px 10px', background: '#7b1fa2', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>
                  복사
                </button>
              )}
            </div>
            <div style={{
              minHeight: 300, padding: 16, fontSize: 15, lineHeight: 1.7,
              whiteSpace: 'pre-wrap', color: result ? '#212529' : '#ccc'
            }}>
              {loading ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 250, color: '#7b1fa2' }}>
                  <div>번역 중입니다...</div>
                </div>
              ) : (
                result || '번역 결과가 여기에 표시됩니다.'
              )}
            </div>
            <div style={{ padding: '8px 16px', borderTop: '1px solid #eee' }}>
              <span style={{ fontSize: 12, color: '#aaa' }}>{result ? result.length + '자' : ''}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TranslateAgent;
